import { useQuery } from "@apollo/client";
import { Spinner } from "grommet";
import { useState } from "react";
import { GET_TOP_TIPPERS } from "../../../queries/user_queries";
import { DateRange } from "../../../types/Util";
import DashCard from "./DashCard";

const TopTippersCard = () => {
  const [selectedRange, setSelectedRange] = useState(
    DateRange.MONTH.toLowerCase()
  );

  const {
    loading,
    error,
    data: userData,
  } = useQuery(GET_TOP_TIPPERS, {
    variables: { range: selectedRange },
  });

  let tippers;
  if (!userData?.getTopTippers) {
    return <Spinner />;
  } else {
    tippers = userData.getTopTippers.map((t: any) => {
      return { username: t.username, tokens: t.tokens.toLocaleString() };
    });
  }

  const rangeOptions = Object.values(DateRange).slice(
    0,
    Object.values(DateRange).length - 1
  );
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedRange(event.target.value as DateRange); // Cast to Color enum type
  };
  return (
    <DashCard
      title="Top tippers"
      aside={
        <select
          className="select select-bordered select-sm"
          value={selectedRange}
          onChange={handleChange}
          aria-label="Range"
        >
          {rangeOptions.map((r) => (
            <option key={r.toLocaleLowerCase()} value={r.toLowerCase()}>
              {r}
            </option>
          ))}
        </select>
      }
    >
      {tippers.length === 0 ? (
        <div className="text-sm text-base-content/60">No tips in this range.</div>
      ) : (
        <ol className="flex flex-col gap-1 max-h-72 overflow-y-auto pr-1">
          {tippers.map((t: any, index: number) => (
            <li
              key={t.username}
              className={`flex items-center justify-between rounded-box px-3 py-2 ${
                index === 0 ? "bg-primary text-primary-content" : "bg-base-200"
              }`}
            >
              <span className="flex items-center gap-2 min-w-0">
                <span className="text-xs opacity-70 w-5 shrink-0">{index + 1}.</span>
                <span className="truncate">{t.username}</span>
              </span>
              <span className="font-semibold">{t.tokens}</span>
            </li>
          ))}
        </ol>
      )}
    </DashCard>
  );
};

export default TopTippersCard;
